import useAuthenticatedAxios from "./use-authenticated-axios";
import { DocType } from "../utils/constants/documents";
import useSWRImmutable from "swr/immutable";

export default function useDocumentBlob({
  downloadUrl,
  documentId,
  doctype = DocType.GENERIC_FILE,
  params = {},
}) {
  const axios = useAuthenticatedAxios();
  let url = null;
  if (documentId) {
    url = `documents/${documentId}/download`;
  } else if (downloadUrl) {
    url = downloadUrl;
  }

  const {
    data: blob,
    error,
    isLoading,
    mutate,
  } = useSWRImmutable(
    url ? [url, params] : null,
    ([url]) => {
      return axios
        .get(url, {
          responseType: "blob",
          params: { doctype, ...params },
        })
        .then((res) => res.data);
    },
    {
      shouldRetryOnError: (error) => {
        // We skip retrying if the API is returning 404
        return error.response?.status !== 404;
      },
    },
  );

  return {
    blob,
    error,
    isLoading,
    refresh: () => mutate(),
  };
}
